"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
var _react = _interopRequireDefault(require("react"));
var _2 = require("./..");
var _components = require("../../components");
var _utils = require("../../utils");
var _util = require("./util");
var _reactRouterDom = require("react-router-dom");
require("./GroupList.less");
var _types = require("../../types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var groupListConfig = function groupListConfig() {
  var definitions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isAdmin = arguments.length > 1 ? arguments[1] : undefined;
  var history = arguments.length > 2 ? arguments[2] : undefined;
  var onRow = function onRow(record, rowIndex) {
    return {
      onClick: function onClick() {
        return definitions.onRowClick(record, rowIndex);
      }
    };
  };
  var columns = [{
    title: 'Status',
    dataIndex: 'status',
    filters: Object.entries(_types.GroupStatus).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        label = _ref2[0],
        id = _ref2[1];
      return {
        value: id,
        text: label
      };
    }),
    onFilter: (0, _utils.filter)('status'),
    defaultFilteredValue: isAdmin ? [_types.GroupStatus.Active] : null,
    render: function render(text, _ref3) {
      var status = _ref3.status;
      return _utils.GroupStatusText[status];
    },
    width: '100px'
  }, {
    title: 'Name',
    dataIndex: 'name',
    width: '200px',
    sorter: (0, _utils.stringSorter)('name'),
    defaultSortOrder: 'ascend'
  }, {
    title: 'Day and Time',
    width: '200px',
    render: function render(_, record) {
      return _utils.GroupUtil.renderRecurringTimesText(record.groupSessions);
    }
  }, {
    title: 'Owner',
    dataIndex: 'owner',
    render: function render(text, _ref4) {
      var clinician = _ref4.clinician;
      return (0, _2.renderNameColumn)(text, clinician);
    },
    width: '200px',
    sorter: (0, _utils.stringSorter)(function (group) {
      return group.clinician.lastName;
    })
  }, {
    title: 'Webinar',
    dataIndex: 'isWebinar',
    render: function render(text, _ref5) {
      var isWebinar = _ref5.isWebinar;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "flex justify-center"
      }, /*#__PURE__*/_react.default.createElement(_components.Checkbox, {
        checked: isWebinar,
        disabled: true
      }));
    },
    width: '50px'
  }, {
    title: 'Description',
    dataIndex: 'description',
    width: '270px'
  }, {
    title: 'Capacity',
    dataIndex: 'capacity'
  }, {
    title: 'Video Link',
    dataIndex: 'id',
    render: function render(text, _ref6) {
      var status = _ref6.status,
        id = _ref6.id;
      var onJoinCall = function onJoinCall(event) {
        event.stopPropagation();
        history.push("group-video/".concat(id));
      };
      if (isAdmin) {
        return (0, _util.patientVideoLink)(id);
      } else {
        return /*#__PURE__*/_react.default.createElement(_button.default, {
          disabled: [_types.GroupStatus.Archived, _types.GroupStatus.ComingSoon].includes(status),
          type: "primary",
          onClick: onJoinCall
        }, "Join Call");
      }
    }
  }];
  return {
    columns: columns,
    onRow: onRow,
    rowKey: 'id'
  };
};
var GroupList = function GroupList(_ref7) {
  var data = _ref7.data,
    loading = _ref7.loading,
    _ref7$definitions = _ref7.definitions,
    defs = _ref7$definitions === void 0 ? {} : _ref7$definitions,
    _ref7$isAdmin = _ref7.isAdmin,
    isAdmin = _ref7$isAdmin === void 0 ? false : _ref7$isAdmin;
  var history = (0, _reactRouterDom.useHistory)();
  var config = groupListConfig(defs, isAdmin, history);
  return /*#__PURE__*/_react.default.createElement(_components.DataTable, _extends({}, config, {
    dataSource: data,
    loading: loading,
    scroll: {
      x: false
    }
  }));
};
var _default = GroupList;
exports.default = _default;